import { atom } from "jotai";

const usersAtom = atom([]);
usersAtom.debugLabel = "List of users for conversation";

const chosenUserAtom = atom<any>({});
chosenUserAtom.debugLabel = "User currently chosen for conversation";

const conversationAtom = atom<any>(null);
conversationAtom.debugLabel = "Current Conversation";

// Cache for conversations to avoid flickering
const conversationsCacheAtom = atom<{[key: string]: any}>({});
conversationsCacheAtom.debugLabel = "Conversations Cache";

export {
    usersAtom,
    chosenUserAtom,
    conversationAtom,
    conversationsCacheAtom
}